module.exports = __webpack_public_path__ + "img/tn.387ea221.svg";